import React, { useEffect, useRef, useState } from "react";
import "./CancelServices.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import CustomInput from "components/widgets/custom-input/CustomInput";
import { Link } from "react-router-dom";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { IconTrash } from "assets/SVGs/SVGs";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getContactUsApi,
  setSessionExpiryModalVisibility,
} from "redux/auth/actions";
import { formatDate, formatPhoneNumber, isEmpty, isSessionTimeExpired } from "utility";
import alerts from "constants/alerts";
import { useHistory } from "react-router-dom";
import { cancelSubscription, getCancelSubscriptionFormDetail } from "redux/MedicalAlertUsers/actions";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import CustomSelectBox from "components/widgets/custom-select-box/CustomSelectBox";
import ChangesSavedModal from "components/layout/changes-saved-modal/ChangesSavedModal";
import InformationModal from "components/layout/information-modal/InformationModal";

const CancelServices = () => {
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const callLinkRef = useRef(null);

  const [cancelServicesData, setCancelServicesData] = useState({
    subscriberName: "",
    subscriberAccountNumber: "",
    subscriberPhoneNumber: "",
    documentList: [],
    loading: false,
    cancelReasonOther: "",
  });
  const [snackBarMessage, setSnackBarMessage] = useState({
    message: "",
    type: "",
  });
  const [selectedReason, setSelectedReason] = useState('')
  const [showSavedModal, setShowSavedModal] = useState(false)
  const { accountHolderData } = useSelector((store) => store?.userDetail);
  const { loading } = useSelector((store) => store?.medicalAlertUsers);
  const userData = useSelector((store) => store?.auth?.userData);
  const { cancelSubscriptionDetail } = useSelector((store) => store?.medicalAlertUsers)
  const contactData = useSelector((store) => store?.auth?.contactUsDetails);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const medicalUserData = location?.state?.medicalUserData;

  useEffect(() => {

    handleFieldChange(
      "subscriberAccountNumber",
      medicalUserData?.account_no,
      false
    );

    getContactUsApi(
      dispatch,
      !userData?.isGuestUser ? "accountowner" : "guestuser"
    );
    const params = {
      dispatch,
      payload: {
        medical_alert_user_id: medicalUserData?.medical_alert_user_id
      },
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      history
    }
    getCancelSubscriptionFormDetail(params)
  }, []);

  const handleFieldChange = (key, value, isNumeric = true) => {
    let numericText = value;
    if (isNumeric) {
      numericText = value.replace(/[^0-9]/g, "");
    }
    setCancelServicesData((prevState) => ({
      ...prevState,
      [key]: numericText,
    }));
  };


  const handlePhoneNumberChange = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e?.target?.value);
    handleFieldChange("subscriberPhoneNumber", formattedPhoneNumber, false);
  };

  const onSubmitPress = async () => {
    let timeDifference = await isSessionTimeExpired();
    if (selectedReason === "Other" && isEmpty(cancelServicesData?.cancelReasonOther)) {
      setSnackBarMessage({
        message: titles?.wriite_reason
      })
    } else if (timeDifference) {
      setSessionExpiryModalVisibility(dispatch, true);
      return;
    } else {
      let payload = {
        medical_alert_user_id: medicalUserData?.medical_alert_user_id?.toString(),
        account_holder_phone_no: cancelServicesData?.subscriberPhoneNumber,
        cancel_reason: selectedReason
      }
      if (selectedReason === "Other") {
        payload = {
          ...payload,
          cancel_reason_other: cancelServicesData?.cancelReasonOther
        }
      }

      const params = {
        dispatch,
        setSnackBarMessage,
        history,
        payload,
        medical_alert_user_id: medicalUserData?.medical_alert_user_id,
        setShowSavedModal
      };
      cancelSubscription(params);
    }
  };
  const subscriberInformation = (titleToRender, isGrey) => {
    return (
      <p className={`display_h4 cs_subsctiber_information  mb10 ${isGrey ? "cs_subsctiber_information_value" : null}`}>
        {titleToRender}
      </p>
    )

  }

  const handleDropdownSelect = (selectedOption, value) => {
    setSelectedReason(selectedOption?.value)
  }

  const getCancelReason = (cancelReason = []) => {
    const updateList = cancelReason?.map((ele) => {
      return {
        label: ele?.value,
        value: ele?.key,
        id: ele?.key,
      };
    });
    return updateList;
  };

  return (
    <MainLayout
      text={titles?.cancel_services}
      isBackHide={false}
      isSemiHeader={true}
      white={true}
      isLoading={loading}
      snackBarMessage={snackBarMessage}

    >
      <ChangesSavedModal
        show={showSavedModal}
        onClose={() => {
          setShowSavedModal(false);
          history.goBack();
        }}
        setShow={setShowSavedModal}
        titleText={`${titles?.cancel_success_message}${contactData?.customer_care_no}`}
        isAutoHide={false}
      />

      {
        subscriberInformation(
          titles?.suscriber_information
        )
      }
      {
        subscriberInformation(
          cancelSubscriptionDetail?.customer_name,
          true
        )
      }
      {subscriberInformation(
        titles?.billingPlan
      )}
      {subscriberInformation(
        cancelSubscriptionDetail?.billing_plan, true
      )}
      {subscriberInformation(
        titles?.next_renew_data
      )}

      {subscriberInformation(
        formatDate(cancelSubscriptionDetail?.next_renewal_date), true
      )}


      <p className="body_h1 cs_end_contract_text ">
        {titles?.cancel_description}
      </p>

      <CustomSelectBox
        selectedValue={selectedReason}
        onChange={handleDropdownSelect}
        options={getCancelReason(cancelSubscriptionDetail?.cancel_reason)}
        title={titles?.select_issue_type}
        className={"cs_select_dropdown"}
      />

      {selectedReason === "Other" ?
        <>
          <span className="body_h1 cs_end_contract_text mb10">
            {titles?.cancel_other_title}
          </span>
          <CustomInput
            placeholderStyle="bd_placeholder_style"
            placeholder={titles?.cancel_other_reason}
            type="text"
            className="mb15"
            value={cancelServicesData?.cancelReasonOther}
            onChange={(e) => {
              handleFieldChange('cancelReasonOther', e?.target?.value, false)
            }}
            multiline={true}
          />
        </> : null}

      <span className="body_h1 cs_end_contract_text">
        {titles?.contact_description}
      </span>
      <CustomInput
        placeholderStyle="bd_placeholder_style"
        placeholder={titles?.cs_phone_number_placeholder}
        type="text"
        className="mb15"
        value={cancelServicesData?.subscriberPhoneNumber}
        onChange={(e) => {
          handlePhoneNumberChange(e);
        }}
      />

      <CustomButton
        height={"50px"}
        className={"mb20 cs_submit_btn"}
        text={titles?.submit_request}
        onClick={onSubmitPress}
      />
    </MainLayout>
  );
};

export default CancelServices;
